// extracted by mini-css-extract-plugin
module.exports = {"container":"CoordsMap_container__1Scq5","backgrounBlur":"CoordsMap_backgrounBlur__30t3W"};